import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.14 Case 14</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_114"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, four, or 114. This
                is a negative case. Beginning at the level of the cerebellum and
                moving superiorly, we enter into the temporal lobes, seen here.
                Distinct white matter tracts can be seen at this level,
                identified here on the left, as well as on the right. Less
                intense activity is seen surrounding the white matter tracts.
                This is the gray matter on the right-hand side as well as on the
                left-hand side. Again moving superiorly and entering into the
                occipital lobes, once again distinct white matter tracts can be
                seen on both sides. If there is concern that there is mildly
                increased activity near the cortical rim, it is imperative that
                you follow these tracts to ensure that they are, in fact, white
                matter, as can be seen here. Therefore, the temporal and
                occipital lobes are negative. There is no loss of gray-white
                contrast. Moving to the anterior aspect of the brain to the
                frontal cortices, distinct white matter, finger-like projections
                can be seen on the left as well as on the right. These typical
                concave patterns created by the white matter indicate that there
                is preserved gray-white contrast throughout the left and the
                right frontal cortices. As we continue moving superiorly,
                distinct white matter tracts can be seen coursing from the front
                of the brain to the back of the brain, on the left as well as on
                the right. In the posterior parietal region, there is no loss of
                gray-white contrast, seen here or here. After reviewing all the
                slices within this case, it is clear that there is no loss of
                gray-white contrast. Therefore, this case is negative. If you
                called this case positive, please review the case once again in
                the MIM Viewer.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-13"
          nextLesson="/module-3/module-3-0-15"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2047219357&entry_id=1_v4c2unnk&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_v4c2unnk"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
